import { fetchPublicPaymentMethodsCountBySupplierAndUser } from "components/orderSummary/orderSummaryPublicPaymentActions";
import { getAuthCookie } from "utils/authCookies";
import { safeConsole } from "utils/envUtils";

export type SendQuoteOrderKind = "sales" | "installation" | "removal";

const SEND_QUOTE_TRIGGERS = {
  sales: {
    withApprove: "salesorder_sendquote",
    paymentCard: "salesorder_sendquote_paymentcard",
  },
  installation: {
    withApprove: "installationjobs_sendquote",
    paymentCard: "installationjobs_sendquote_paymentcard",
  },
  removal: {
    withApprove: "removaljobs_sendquote",
    paymentCard: "removaljobs_sendquote_paymentcard",
  },
} as const;

function normalizeOrderUserId(value: unknown): string {
  if (value == null) return "";
  if (typeof value === "object") {
    const obj = value as { id?: unknown; $oid?: unknown };
    if (obj.id != null) return String(obj.id).trim();
    if (obj.$oid != null) return String(obj.$oid).trim();
  }
  return String(value).trim();
}

/**
 * Pick send-quote trigger from the same rule as Order Summary Approve:
 * payment methods on file → *_sendquote (Approve available);
 * otherwise → *_sendquote_paymentcard (credit-card / review & payment).
 */
export async function resolveSendQuoteEmailTrigger(
  kind: SendQuoteOrderKind,
  order: any
): Promise<string> {
  const triggers = SEND_QUOTE_TRIGGERS[kind];
  const supplierId =
    normalizeOrderUserId(getAuthCookie("userId")) ||
    normalizeOrderUserId(order?.signage_id) ||
    normalizeOrderUserId(order?.seller_owner_node_id) ||
    normalizeOrderUserId(order?.created_by);

  const payerId =
    kind === "sales"
      ? normalizeOrderUserId(order?.customer_id)
      : normalizeOrderUserId(order?.agent_id) ||
        normalizeOrderUserId(order?.team_member_id) ||
        normalizeOrderUserId(order?.customer_id);

  if (!supplierId || !payerId) {
    return triggers.paymentCard;
  }

  try {
    const result = await fetchPublicPaymentMethodsCountBySupplierAndUser(supplierId, payerId);
    return result.has_payment_methods ? triggers.withApprove : triggers.paymentCard;
  } catch (e) {
    safeConsole.warn("[resolveSendQuoteEmailTrigger] payment-methods check failed:", e);
    return triggers.paymentCard;
  }
}
